import { datadogRum } from "@datadog/browser-rum";

import { getCookie } from "@utils/cookie";

import { setDatadogRumUser } from "./datadogRumUser";

export const initDatadogRum = () => {
  const applicationId = import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN;
  const site = import.meta.env.VITE_DATADOG_RUM_SITE;
  const version = import.meta.env.VITE_APP_VERSION;
  if (!applicationId || !clientToken) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service: "fe-des",
    version,
    env: "development",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      {
        match: "https://msa.bio-research.dev",
        propagatorTypes: ["datadog", "tracecontext"],
      },
    ],
  });

  const accountEmail = getCookie("accountEmail");
  const accountName = getCookie("accountName");

  if (accountEmail) {
    setDatadogRumUser({ accountEmail, accountName });
  }
};
